<template>
  <v-menu offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <button v-if="user" v-bind="attrs" type="button" v-on="on" @click="$emit('add-members')">
        <Avatar
          :key="user.id"
          :email="user.email"
          :name="user.name"
          :pic="user.files_urls.avatar_thumbnail"
          :size="32"
          class="member-avatar"
        />
      </button>
      <button
        v-else
        v-bind="attrs"
        type="button"
        class="add-member-btn"
        v-on="on"
        @click="$emit('add-members')"
      >
        <PlusIcon />
      </button>
    </template>
    <div class="dropdown-body__avatars">
      <MembersSearch
        :members="team"
        :multi="false"
        :selected-members-ids="selectedIds"
        @select="handleMemberSelect"
      />
    </div>
  </v-menu>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';
  import { VMenu } from 'vuetify/lib';
  import MembersSearch from '@/components/project/tenders/MembersSearch';
  import PlusIcon from '@/assets/icons/rounded-plus.svg';

  export default {
    name: 'ResponsibleUser',
    components: {
      Avatar,
      VMenu,
      MembersSearch,
      PlusIcon,
    },
    props: {
      userId: {
        type: Number,
        required: true,
      },
      team: {
        type: Array,
        required: true,
      },
    },
    computed: {
      user() {
        return this.team.find((user) => user.id === this.userId);
      },
      selectedIds() {
        return this.user?.id ? [this.user.id] : [];
      },
    },
    methods: {
      handleMemberSelect(ids) {
        if (ids.length) this.$emit('select', ids[0]);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .dropdown-body__avatars {
    background-color: white;
  }

  .add-member-btn {
    height: 32px;
    width: 32px;
    border: 1px dashed $grey200;
    background-color: inherit;
    outline: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-left: 1px;

    ::v-deep svg {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10px;
      width: 10px;
      path {
        fill: $neutral2;
      }
    }
  }
</style>
